<template>
    <div>
        <b-row>
            <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_code')">
                                    {{ formData.code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_name')">
                                    {{ getLocaleText(formData, 'name') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_language')">
                                    {{ formData.language }}
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
        </b-row>
        <b-row>
            <b-col md="12" class="mt-2">
                <b-card>
                    <b-row>
                        <b-col md="12">
                            <b-alert variant="info" show>{{ $t('ects_values_info') }}</b-alert>
                        </b-col>
                        <b-col md="12">
                            <b-table
                                :empty-filtered-text="$t('no_result')"
                                :empty-text="$t('no_result')"
                                bordered
                                striped
                                responsive
                                :items="tableData"
                                :fields="tableFields"
                                show-empty
                                class="mb-5 mt-2 table-dropdown no-scrollbar border rounded">
                                <template v-for="(item, index) in tableFields" v-slot:[`head(${item.key})`]="data">
                                    <span v-if="index != 0" class="cursor-pointer" v-b-tooltip.hover :title=item.label>{{ item.key }}</span>
                                    <span v-else>
                                        {{$t('ects_course_program_outcomes')}} <i class="ri-corner-right-down-fill"></i>
                                        & {{$t('ects_objectives')}} <i class="ri-arrow-right-fill"></i>
                                    </span>
                                </template>
                                <template v-for="(item, index) in tableData[0]" v-slot:[`cell(${item.rank})`]="data">
                                    <multi-selectbox
                                        :options="statusOptions"
                                        :multiple="false"
                                        @input="saveData(data.item[index])"
                                        v-if="data.item[index]"
                                        :id="'b-input-'+(index)+'-'+data.item[index].id"
                                        v-model="data.item[index].value" />
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// Components

// Services
import EctsService from "@/services/EctsService"
import ProgramOutcome from "@/services/ProgramOutcome";

// Other
import qs from "qs";

export default {
    components: {

    },
    props: {
        course: {
            type: Object,
        },
        forceRefresh: {
            type: Boolean,
        }
    },
    data() {
        return {
            formData: {},
            tableData: [],
            tableFields: [
                {
                    key: 'info',
                    label: this.$t('ects_course_program_outcomes')
                }
            ],

            statusOptions: [
                {
                    value: "0",
                    text: "-"
                },
                {
                    value: "1",
                    text: "1"
                },
                {
                    value: "2",
                    text: "2"
                },
                {
                    value: "3",
                    text: "3"
                },
                {
                    value: "4",
                    text: "4"
                },
                {
                    value: "5",
                    text: "5"
                }
            ],

        };
    },
    watch: {
        forceRefresh: {
            handler(value) {
                if (value === true) {
                    this.getData()
                }
            }
        }
    },
    created() {
        this.formData = this.course
        this.getData()
    },
    methods: {
        getData(){
            const config = {
                params: {
                    filter: {
                        course_id: this.course.id,
                        semester_id: this.course.semester_id
                    },
                    sort: 'rank'

                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            }
            EctsService.getCourseOutcomesSemesters(config).then(response => {
                response.data.data.forEach(item => {
                    this.tableFields.push({
                        key: item.rank.toString(),
                        label: this.getLocaleField(item.course_outcome_name),
                        course_outcome_id: item.course_outcome_id,
                        rank: item.rank
                    })
                })
            }).finally(() => {
                this.getProgramOutcomesData()
            }).catch(e => {
                this.showErrors(e)
            })
        },

        getProgramOutcomesData(){
            this.tableData = []
            const config = {
                params: {
                    filter: {
                        program_code: this.course.program_program_code,
                        semester_id: this.course.semester_id
                    },
                    sort: 'rank',
                    limit: -1
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            ProgramOutcome.getAll(config).then(response => {
                response.data.data.forEach(itm => {
                    let objData = {}
                    this.tableFields.forEach((item, i) => {
                        if(i > 0){
                            objData[i] = {
                                id: itm.id,
                                course_outcome_id: item.course_outcome_id,
                                value: "0",
                                rank: item.rank
                            }
                        }
                    })
                    this.tableData.push({
                        info: this.getLocaleText(itm, 'name'),
                        ...objData
                    })
                })
            }).finally(() => {
                this.getComputeData()
            }).catch(e => {
                this.showErrors(e)
            })
        },

        getComputeData(){
            EctsService.getProgramCoordinatorCourseProgramOutcomesMatrix().then(response => {
                response.data.data.forEach(itm => {
                    this.tableData.forEach((item,index) => {
                        Object.keys(item).forEach((key) => {
                            if(typeof item[key] == "object" && item[key].course_outcome_id == itm.course_outcome_id && item[key].id == itm.program_outcome_id){
                                this.tableData[index][key].value = itm.value
                            }
                        })
                    })
                })
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        saveData(data) {
            let formData = {
                course_outcome_id: data.course_outcome_id,
                program_outcome_id: data.id,
                value: data.value,
                semester_id: this.course.semester_id
            }
            EctsService.setProgramCoordinatorCourseProgramOutcomesMatrix(formData).then(response => {
                this.$toast.success(this.$t('api.'+response.data.message))
            }).catch(e => {
                this.showErrors(e, null)
            })
        }


    },
}
</script>
